export default {
  about: 'O nás',
  contact: 'Kontakty',
  references: 'Reference',
  technology: 'Technika',
  home: 'Domů',
  facebook: 'Facebook',
  burger: 'Navigation menu',
};
